import { motion } from "framer-motion"; // Import Framer Motion
import { usePageLoading } from "@/hooks/usePageLoading";
import TitleWithContent from "@/components/elements/TitleWithContent/TitleWithContent";
import Paragraph from "@/components/elements/Paragraph/Paragraph";

const AboutUsPage = () => {
  const { isLoading } = usePageLoading();
  return (
    <>
      {/* Same gap below nav as Services page */}
      
      {/* Add Framer Motion to Title */}
      <div className="2xl:px-40 xl:px-35 lg:px-30 md:px-20 px-3 my-[5rem]">
      <motion.div
        initial={{ opacity: 0, scaleX: 0 }}
        animate={!isLoading ? { opacity: 1, scaleX: 1 } : { opacity: 0, scaleX: 0 }}
        transition={{ duration: 0.5 }}
      >
        <TitleWithContent title="About Us" level={1} />
      </motion.div>

      <div className=" 2xl:px-40 xl:px-35 lg:px-30 md:px-20 px-6  "
      >
        {/* Add Framer Motion to Paragraphs with Staggered Children, Fade In, and Scale Effect */}
        <motion.div
          initial="hidden"
          animate="visible"
          variants={{
            hidden: { opacity: 0 },
            visible: {
              opacity: 1,
              transition: { staggerChildren: 0.7, opacity: { duration: 0.5 } },
            },
          }}
          
          className="group text-justify break-normal tracking-normal leading-relaxed "
        >
          {/* Individual Paragraphs with Fade, Scale, and Bounce Effect */}
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0.5,
              ease: "easeOut",
              delay: 0.5,
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
          <Paragraph content={
            <>
              At <span className="span-text">Sheel Waterproofing</span>, we're passionate about keeping
              your home or business safe from water damage. 
              Whether it's a small leak or major moisture issues, 
              our team is here to protect your property with expert waterproofing 
              solutions. Water intrusion isn’t just inconvenient — 
              it can lead to expensive repairs, mold problems, and structural damage. 
              That’s why we offer reliable, long-term solutions you can trust. 
              From basement waterproofing and foundation repair to exterior 
              protection, we bring years of hands-on experience and cutting-edge techniques to every project — big or small.
            </>
          } />

            <br />
          </motion.div>

          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0.5,
              ease: "easeOut",
              delay: 1,
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
          <Paragraph content={
            <>
              What sets us apart is our <span className="span-text">commitment to you — the customer</span>. We understand that every property has unique challenges, so we take the time to listen, inspect, and recommend the best solution tailored to your needs. Our team is always here to answer your questions and keep you informed every step of the way. We use only top-quality materials and stay updated with the latest industry practices to ensure long-lasting protection. At Sheel Waterproofing, your peace of mind is our top priority — rain or shine.
            </>
          } />
            <br />
          </motion.div>

          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0.5,
              ease: "easeOut",
              delay: 1.5,
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
          <Paragraph content={
            <>
              Choosing <span className="span-text">Sheel Waterproofing</span> means partnering with a team that genuinely cares about your satisfaction. We’re proud to deliver high-quality results on time and within budget. Browse through our range of services, check out our recent projects, and feel free to reach out for a free consultation. Whether you're preventing future damage or solving existing issues, trust Sheel Waterproofing to keep your property dry, secure, and worry-free.
            </>
          } />

            <br />
          </motion.div>

          {/* Interactive Section */}
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0.5,
              ease: "easeOut",
              delay: 2,
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
          <Paragraph content={
            <>
            <div className="leading-relaxed tracking-tight">
              <strong className="text-lg">💬 Tell Us About Your Project</strong><br />
              We’d love to hear from you!<br />
              <span>What kind of waterproofing help are you looking for?</span><br />
              Send us a message directly:
              {" "}
              <a 
                href="contact" 
                className="text-custom-secolor underline hover:text-custom-hov"
              >
                Contact Us
              </a>
               {""} —  It only takes 2 minutes
              </div>
            </>
          } />
          </motion.div>

        </motion.div>
      </div>
    </div>
    </>
  );
};

export default AboutUsPage;
